/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type React from 'react';

/**
 * Hauteurs du corps d'un écran INSEE : bornées dans la modale, toute la
 * hauteur disponible dans la page du menu (le tableau défile seul).
 */
export const stylesCorps = (
  pleinePage: boolean,
): Record<'pushable' | 'pusher' | 'tableau', React.CSSProperties> =>
  pleinePage
    ? {
        pushable: { height: '100%', overflow: 'hidden' },
        pusher: { height: '100%' },
        tableau: { height: '100%', overflowY: 'auto' },
      }
    : {
        pushable: { minHeight: '50vh', overflow: 'hidden' },
        pusher: {},
        tableau: { maxHeight: '65vh', overflowY: 'auto' },
      };
